import { TBannerItem } from 'core/domains/content';
import { RootState } from 'core/store';
import { THomeBannerView } from '../../@types/homeBanner';

export const homeBanners = (action: any, prevState: RootState) => {
  const contents = ['page-departments', 'page-departments-multibrand'];
  const bannerInfo = [] as THomeBannerView[];
  Object.keys(prevState.content).forEach((key) => {
    if (!contents.includes(key) || prevState.content[key].status !== 'success') {
      return;
    }
    const carouselComponent = prevState.content[key].data?.components?.find(
      (item) => item.component === 'carousel',
    );
    const { position = 0, type = 'view' } = action.payload;
    const bannerItem = carouselComponent?.items[position] as unknown as TBannerItem;
    bannerInfo.push({
      event: `${type}_promotion`,
      ecommerce: {
        creative_name: bannerItem.image?.url || '',
        creative_slot: position,
        promotion_id: bannerItem.link || '',
        promotion_name: bannerItem.title || bannerItem.text?.[0]?.text || '',
      },
    });
  });

  return bannerInfo;
};
